import React, { useState, useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userCredentials, routeInfo } from "recoilState/GlobalState";
import { Routes } from "consts/Routes-App";
import { zonaGet, accesoGet } from "services/services-mia/miakey";
import { MonitorContent } from "./MonitorContent";
import { log } from "utils/logger";

export default function Monitor() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);

    const [loadingLugares, setLoadingLugares] = useState(true);
    const [errorLugares, setErrorLugares] = useState(null);
    const [zonas, setZonas] = useState([]);
    const [zonaDefault, setZonaDefault] = useState(null);
    const [accesoDefault, setAccesoDefault] = useState("");
    const [accesos, setAccesos] = useState([]);

    useEffect(() => {
        setRoute(Routes.monitorMia);
    }, [setRoute]);

    useEffect(() => {
        if (!credentials?.hooliToken && !credentials?.token) return;

        const fetchInicial = async () => {
            setLoadingLugares(true);
            try {
                const [{ result: resultZonas }, { result: resultAccesos }] = await Promise.all([
                    zonaGet({ gateZonaId: null }, credentials),
                    accesoGet({}, credentials),
                ]);

                const zonasIds = new Set(resultAccesos.map(a => a.gateZonaId));
                const zonasFiltradas = resultZonas.filter(z => zonasIds.has(z.gateZonaId));

                const primeraZona = zonasFiltradas[0];
                const accesosDeprimeraZona = resultAccesos.filter(
                    a => a.gateZonaId === primeraZona?.gateZonaId
                );
                const lugarDefault = accesosDeprimeraZona.find(a => a.gateLugarEsDefault === "Y")
                    ?? accesosDeprimeraZona[0];

                setZonas(zonasFiltradas);
                setAccesos(resultAccesos);
                setZonaDefault(primeraZona?.gateZonaId ?? null);
                setAccesoDefault(lugarDefault?.gateLugarId ?? "");
                setErrorLugares(null);
            } catch (err) {
                log.error("Error cargando datos iniciales del Monitor:", err);
                setErrorLugares("No se pudieron cargar los accesos disponibles");
            } finally {
                setLoadingLugares(false);
            }
        };

        fetchInicial();
    }, [credentials]);

    return (
        <>
            {!loadingLugares && accesoDefault !== "" && (
                <MonitorContent
                    zonas={zonas}
                    accesos={accesos}
                    zonaDefault={zonaDefault}
                    accesoDefault={accesoDefault}
                    credentials={credentials}
                    errorLugares={errorLugares}
                    loadingLugares={loadingLugares}
                />
            )}
            {loadingLugares && (
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    Cargando accesos...
                </div>
            )}
        </>
    );
}